export const ROLES = {
    ALL: 'ALL',
    ADMIN: 'ADMIN',
    OWNER: 'OWNER',
    PARTNER: 'PARTNER',
    USER: "USER"
}

export const ROLE_TYPE_MENU = [
    { label: '전체', value: ROLES.ALL },
    { label: 'ADMIN', value: ROLES.ADMIN },
    { label: 'OWNER', value: ROLES.OWNER },
    { label: 'PARTNER', value: ROLES.PARTNER },
    { label: 'USER', value: ROLES.USER },
]

export type Role = keyof typeof ROLES;